import {Button} from '@dropbox/dig-components/buttons';
import {Text} from '@dropbox/dig-components/typography';
import {Box} from '@dropbox/dig-foundations';
import {UIIcon} from '@dropbox/dig-icons';
import {PersonMultipleLine} from '@dropbox/dig-icons/assets';
import {analyticsLogger} from 'analytics/analyticsLogger';
import {Employee} from 'client';
import {Title} from 'components/DSYS/Title';
import ProfileCard from 'components/shared/ProfileCard';
import {t} from 'i18next';
import {useMemo, useState} from 'react';

import styles from './ProfileEmployees.module.css';

interface ProfileEmployeesProps {
  sectionTitle: string;
  employees: Employee[];
  employee: Employee;
  source: string;
  collapsedLimit?: number;
}

export const ProfileEmployees = (props: ProfileEmployeesProps) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const filteredEmployees = useMemo(
    () =>
      props.employees.filter(
        // TODO: Move to server
        (person) => person.ldap !== 'donotuse' && person.ldap !== props.employee.ldap
      ),
    [props.employee.ldap, props.employees]
  );
  const collapsedLimit = props.collapsedLimit;
  const hasCollapsedState =
    collapsedLimit !== undefined && filteredEmployees.length > collapsedLimit;
  const displayedEmployees =
    hasCollapsedState && !isExpanded
      ? filteredEmployees.slice(0, collapsedLimit)
      : filteredEmployees;

  return (
    <Box
      paddingX="20"
      paddingY="16"
      borderWidth="1"
      borderColor="Border Subtle"
      borderRadius="Medium"
      borderStyle="Solid"
      className={styles.profileReportsSection}
    >
      <Text isBold size="xlarge"></Text>
      <Title size={16} withAccessoryStart={<UIIcon src={PersonMultipleLine} isOpticallyAligned />}>
        {props.sectionTitle}
      </Title>
      <div className={styles.profileReportsList}>
        {displayedEmployees.map((person, index) => (
          <ProfileCard
            key={index + (person.ldap ?? person.user_id)}
            source={props.source}
            display_name={person.name}
            profile_info={person.role || ''}
            profile_photo_url={person.profile_photo_url}
            profile_username={person.ldap ?? person.user_id}
            isDeactivated={person.is_deactivated}
            directReportsCount={person.direct_report_count}
            totalReportsCount={person.total_report_count}
            onClick={() =>
              analyticsLogger().logEvent('PROFILE_INTERACTION', {action: props.source})
            }
          />
        ))}
      </div>
      {hasCollapsedState && (
        <Box paddingTop="12">
          <Button
            variant="transparent"
            size="small"
            onClick={() => setIsExpanded((current) => !current)}
          >
            {isExpanded
              ? t('show_less')
              : t('show_more_count', {count: filteredEmployees.length - collapsedLimit})}
          </Button>
        </Box>
      )}
    </Box>
  );
};
